<template>
  <div v-if="user">
    <el-row
      class="hidden-md-and-up"
      type="flex"
      justify="space-between"
      align="center"
    >
      <el-col :span="24">
        <div>
          <div>
            <el-image v-if="user" :src="user.picture" :fit="'cover'"></el-image>
            <h2>{{ user.name }}</h2>

            <p class="lead text-muted">{{ user.email }}</p>
          </div>
        </div>
        <el-divider></el-divider>
      </el-col>
    </el-row>

    <el-row :gutter="20" type="flex" justify="space-between" align="center">
      <el-col
        class="hidden-sm-and-down"
        :xs="24"
        :sm="8"
        :md="8"
        :lg="8"
        :xl="6"
      >
        <el-image v-if="user" :src="user.picture" :fit="'cover'"></el-image
      ></el-col>
      <el-col :order="2" :xs="24" :sm="16" :md="24" :lg="24" :xl="24">
        <h1><a href="#favorites">Favorites</a></h1>
        <Quotes
          @postfav="postedFav()"
          v-if="favorites.length"
          :quotes="favorites"
        />
      </el-col>
    </el-row>
    <el-backtop target=".el-main"></el-backtop>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import fav from "../mixins/fav";
import Quotes from "../components/Quotes.vue";
export default {
  computed: {
    ...mapGetters({
      user: "getUser"
    })
  },
  components: {
    Quotes
  },
  data() {
    return {
      favorites: []
    };
  },
  mixins: [fav],
  mounted() {
    this.getFavorites(true);
  },
  methods: {
    async postedFav() {
      await this.getFavorites();
    },
    async getFavorites(load) {
      this.favorites = [];
      let loading;
      if (load) {
        loading = this.$loading({
          lock: true,
          background: "rgba(0, 0, 0, 0.7)"
        });
      }
      this.favorites = await this.getFavs2();
      if (load) loading.close();
    }
  }
};
</script>
<style scoped>
.el-image {
  min-height: 250px;
  max-width: 300px;
  width: 42vw;
}

@media only screen and (max-width: 490px) {
  .el-image {
    width: 65vw;
  }
}
</style>
